export default __webpack_public_path__ + "static/media/img57.8b7e1d5d.jpg";